/*
 * View for an API config item
 */

define(["marionette", "./template/apiConfigModalTemplate.html"], function (
  Marionette,
  ApiConfigModalTemplate,
) {
  var ApiConfigModalView = {};

  ApiConfigModalView.apiConfigModalView = Marionette.ItemView.extend({
    template: ApiConfigModalTemplate,
    getNameValue: function () {
      return this.$el.find("#apiName").val();
    },
    getUrlValue: function () {
      return this.$el.find("#endpointUrl").val();
    },
    getRateLimit: function () {
      return parseInt(this.$el.find("#rateLimit").val(), 10);
    },
    getAuthenticationType: function () {
      return parseInt(this.$el.find("#authenticationType option:selected").val(), 10);
    },
    getUsername: function () {
      return this.$el.find("#basicAuthUser").val();
    },
    getPassword: function () {
      var password = this.$el.find("#basicAuthPassword").val();
      //do not return the dummy password
      if (password !== "*******") return password;
      return null;
    },
    getKeyLocation: function () {
      return parseInt(this.$el.find("input[name=keyLocation]:checked").val(), 10);
    },
    getKeyName: function () {
      return this.$el.find("#keyAuthName").val();
    },
    getApiKey: function () {
      return this.$el.find("#keyAuthAPIKey").val();
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#nameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    urlError: function (errorMessage) {
      this.$el
        .find("#urlError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    rateLimitError: function (errorMessage) {
      this.$el
        .find("#rateLimitError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    userError: function (errorMessage) {
      this.$el
        .find("#userError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    passwordError: function (errorMessage) {
      this.$el
        .find("#passwordError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    keyError: function (errorMessage) {
      this.$el
        .find("#keyError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    keyNameError: function (errorMessage) {
      this.$el
        .find("#keyNameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
    toggleAuthenticationPane: function (authType) {
      this.$el.find("#basicAuthConfig, #keyAuthConfig").addClass("hidden");
      if (authType == 1) {
        this.$el.find("#basicAuthConfig").removeClass("hidden");
      } else if (authType == 2) {
        this.$el.find("#keyAuthConfig").removeClass("hidden");
      }
    },
    events: {
      "change #authenticationType": function () {
        this.toggleAuthenticationPane(this.getAuthenticationType());
      },
      "click #basicAuthPassword": function () {
        if (this.getPassword() == null) {
          this.$el.find("#basicAuthPassword").val("");
        }
      },
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return ApiConfigModalView;
});
